import { Product } from '@interfaces/index';
import 'firebase/database';
import firebase from 'gatsby-plugin-firebase';
import { useListVals } from 'react-firebase-hooks/database';

export const useProducts = () => {
  const [products, loading, error] = useListVals<Product>(
    firebase
      .database()
      .ref('/restaurants/d-vero/products')
      .orderByChild('order'),
      {
        keyField: 'uuid'
      }
  );
  return {
    products,
    loading,
    error,
  };
};